/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetLeadMergeTasks200Response } from '../models';
/**
 * LeadMergeTaskApi - axios parameter creator
 * @export
 */
export const LeadMergeTaskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * リード重複統合タスク取得API
         * @summary リード重複統合タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadMergeTasks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/lead_merge_tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リード重複統合タスクconfirm API
         * @summary リード重複統合タスクconfirm API
         * @param {number} leadMergeTaskId リード重複統合タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLeadMergeTask: async (leadMergeTaskId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadMergeTaskId' is not null or undefined
            assertParamExists('putLeadMergeTask', 'leadMergeTaskId', leadMergeTaskId)
            const localVarPath = `/api/user/lead_merge_tasks/{leadMergeTaskId}`
                .replace(`{${"leadMergeTaskId"}}`, encodeURIComponent(String(leadMergeTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadMergeTaskApi - functional programming interface
 * @export
 */
export const LeadMergeTaskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadMergeTaskApiAxiosParamCreator(configuration)
    return {
        /**
         * リード重複統合タスク取得API
         * @summary リード重複統合タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadMergeTasks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLeadMergeTasks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadMergeTasks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リード重複統合タスクconfirm API
         * @summary リード重複統合タスクconfirm API
         * @param {number} leadMergeTaskId リード重複統合タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putLeadMergeTask(leadMergeTaskId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putLeadMergeTask(leadMergeTaskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LeadMergeTaskApi - factory interface
 * @export
 */
export const LeadMergeTaskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadMergeTaskApiFp(configuration)
    return {
        /**
         * リード重複統合タスク取得API
         * @summary リード重複統合タスク取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadMergeTasks(options?: any): AxiosPromise<GetLeadMergeTasks200Response> {
            return localVarFp.getLeadMergeTasks(options).then((request) => request(axios, basePath));
        },
        /**
         * リード重複統合タスクconfirm API
         * @summary リード重複統合タスクconfirm API
         * @param {number} leadMergeTaskId リード重複統合タスクのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLeadMergeTask(leadMergeTaskId: number, options?: any): AxiosPromise<void> {
            return localVarFp.putLeadMergeTask(leadMergeTaskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadMergeTaskApi - interface
 * @export
 * @interface LeadMergeTaskApi
 */
export interface LeadMergeTaskApiInterface {
    /**
     * リード重複統合タスク取得API
     * @summary リード重複統合タスク取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadMergeTaskApiInterface
     */
    getLeadMergeTasks(options?: AxiosRequestConfig): AxiosPromise<GetLeadMergeTasks200Response>;

    /**
     * リード重複統合タスクconfirm API
     * @summary リード重複統合タスクconfirm API
     * @param {number} leadMergeTaskId リード重複統合タスクのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadMergeTaskApiInterface
     */
    putLeadMergeTask(leadMergeTaskId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putLeadMergeTask operation in LeadMergeTaskApi.
 * @export
 * @interface LeadMergeTaskApiPutLeadMergeTaskRequest
 */
export interface LeadMergeTaskApiPutLeadMergeTaskRequest {
    /**
     * リード重複統合タスクのID
     * @type {number}
     * @memberof LeadMergeTaskApiPutLeadMergeTask
     */
    readonly leadMergeTaskId: number
}

/**
 * LeadMergeTaskApi - object-oriented interface
 * @export
 * @class LeadMergeTaskApi
 * @extends {BaseAPI}
 */
export class LeadMergeTaskApi extends BaseAPI implements LeadMergeTaskApiInterface {
    /**
     * リード重複統合タスク取得API
     * @summary リード重複統合タスク取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadMergeTaskApi
     */
    public getLeadMergeTasks(options?: AxiosRequestConfig) {
        return LeadMergeTaskApiFp(this.configuration).getLeadMergeTasks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リード重複統合タスクconfirm API
     * @summary リード重複統合タスクconfirm API
     * @param {LeadMergeTaskApiPutLeadMergeTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadMergeTaskApi
     */
    public putLeadMergeTask(requestParameters: LeadMergeTaskApiPutLeadMergeTaskRequest, options?: AxiosRequestConfig) {
        return LeadMergeTaskApiFp(this.configuration).putLeadMergeTask(requestParameters.leadMergeTaskId, options).then((request) => request(this.axios, this.basePath));
    }
}
